import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-chevron-double-right",
  templateUrl: "./chevron-double-right.component.html",
  styleUrls: ["./chevron-double-right.component.scss"],
})
export class ChevronDoubleRightComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
